import { useEffect, useRef } from 'react';
import PageLoader from 'src/UI/loader/PageLoader';
import { Logger } from 'src/utils/Logger';
import { useLogout } from 'src/auth/hooks/useLogout';

export function LogoutPage() {
  const hasLoggedOut = useRef(false);

  const { mutate: logout } = useLogout({
    onError: error => {
      Logger.error('Logout failed', error);
      window.location.replace('/login');
    },
  });

  useEffect(() => {
    if (!hasLoggedOut.current) {
      hasLoggedOut.current = true;
      logout();
    }
  }, [logout]);

  return <PageLoader />;
}
